import { useNavigate, useLocation } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import { AvatarImg } from '../shared/Avatar';

export function Header() {
  const { currentUser } = useApp();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <header className="relative shrink-0 bg-slate-800" style={{ paddingTop: 'var(--sat)' }}>
      <div className="h-[2px] bg-accent" />
      <div className="flex items-center justify-between px-4 py-2">
        <h1 className="text-base font-bold text-slate-50">Rost & Found</h1>
        <button
          data-tour="header-profile"
          onClick={() => location.pathname === '/profile' ? navigate(-1) : navigate('/profile')}
          className="flex items-center gap-2.5 active:opacity-70 transition-opacity"
        >
          <span className="text-xs font-medium text-slate-400">@{currentUser.handle}</span>
          <div className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold ring-2 ring-offset-1 ring-offset-slate-800 ring-accent/50 bg-accent text-white">
            <AvatarImg src={currentUser.avatarUrl} name={currentUser.name} className="w-full h-full object-cover rounded-full" />
          </div>
        </button>
      </div>
    </header>
  );
}
